import {Injectable} from "@angular/core";
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs";
import {catchError, switchMap} from 'rxjs/operators';
import {environment} from "../../environments/environment";
import {AuthService} from "./auth.service";

@Injectable()
export class JwtInterceptorService implements HttpInterceptor {


  constructor(private authService: AuthService) {
  }


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    if (!request.url.includes(environment.apiUrl)) {
      return next.handle(request.clone({
        headers: request.headers.delete('Authorization'),
      }));
    }

    return this.authService
      .getToken()
      .pipe(
        switchMap(token => {
          if (!token) return next.handle(request);
          return next.handle(request.clone({
            setHeaders: {Authorization: `Bearer ${token}`}
          }));
        })
      );
  }


}





